import AgreementItem from './agreements-value';
import { AggrementContentTypes } from './types';

const AgreementContent = ({
  agreementGroup,
  customerType,
}: AggrementContentTypes) => (
  <AgreementItem
    item={agreementGroup[0]}
    earlyVersions={agreementGroup.slice(1)}
    customerType={customerType}
  />
);

export default AgreementContent;
